import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchProjects } from "../../utils/requests";
import { ProjectPopupMobile } from "./project-popup/project-popup-mobile";
import { useLocation } from 'react-router-dom';
import { Config } from "../../config/config";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./project-gallery-mobile.css";

const ProjectGalleryMobile = ({ minimified = false, textes }) => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  let location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash && hash.includes("#projets")) {
      const element = document.getElementById(hash.split("#")[1]);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const loadProjects = () => {
    fetchProjects().then((data) => {
      const projects = data.data.map((project) => ({
        id: project.id,
        date: project.attributes.date,
        title: project.attributes.title,
        description: project.attributes.description,
        thumbnail: project.attributes.thumbnail.data.attributes.url,
        brand: project.attributes.brand.data.attributes.url,
        youtube_urls: project.attributes.youtube_urls
          ?.split("\n")
          .map((video) => ({
            url: video,
          })),
      }));
      projects.sort((a, b) => new Date(b.date) - new Date(a.date));
      setProjects(projects);
    });
  };

  useEffect(() => {
    loadProjects();
  }, []);

  const handleOpen = (project) => {
    setSelectedProject(project);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div id="projets" className="bg-projects">
      <div className="framer-section">
        <h1 className="projects-title-mobile text-left projects-title text-7xl sm:text-7xl md:text-6xl lg:text-6xl xl:text-7xl mb-12">
          {textes?.caseStudiesTitle || "case studies"}
        </h1>

        <div className="project-carousel-container flex flex-col items-center">
          <Carousel
            showThumbs={false}
            showStatus={false}
            showIndicators={false}
            // infiniteLoop={true}
            centerMode={true}
            centerSlidePercentage={window.innerWidth < 768 ? 60 : 30}
            className="project-carousel"
            swipeable={false}
            emulateTouch={false}
            dynamicHeight={false}
            onClickItem={(index, item) => handleOpen(projects[index])}
          >
            {projects.map((project, index) => (
              <div
                key={project.id}
                className="project-card-carousel-mobile"
                // onClick={() => handleOpen(project)}
              >
                <div className="project-card-image-container-mobile">
                  <img
                    src={Config.api.mediaUrl + project.thumbnail}
                    alt={project.title}
                    className="project-card-image-mobile"
                  />
                </div>
                <div className="project-card-content-mobile">
                  <h3 className="project-card-title">
                    {project.title}
                  </h3>
                  {project.description && (
                    <p className="project-card-description">
                      {project.type || "Motion design"}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </Carousel>

          {!minimified && (
            <Link to="/gallery">
              <button className="flex items-center p-4 md:p-2 lg:p-4 bg-black text-white shadow-lg mb-8 font-bold text-xl md:text-sm lg:text-sm">
                {textes?.discoverMoreProjects || "Découvrir plus de projets"}
              </button>
            </Link>
          )}
        </div>

        <ProjectPopupMobile
          isOpen={isOpen}
          onClose={handleClose}
          project={selectedProject}
        />
      </div>
    </div>
  );
};

export default ProjectGalleryMobile;